import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import './lib/thema';
import { App } from './App';
import { Foutgrens } from './ui/Foutgrens';
import './styles.css';

const qc = new QueryClient({ defaultOptions: { queries: { retry: 1 } } });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <BrowserRouter>
        <Foutgrens>
          <App />
        </Foutgrens>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);
